<!-- Shared pricing display template for rush parts extended to branch -->
<ng-template #pricingDisplayTemplate let-vm="vm">
  <div>
    <!-- Zilliant Pricing -->
    @if (showPriceIq && part.walkIn > part.listPrice) {
      <div id="pricing_div_ZilliantPricing{{idSuffix}}">
        <div class="strong text-muted">{{ useCaps ? "EVERYDAY PRICE" : "Everyday Price" }}</div>
        <h3 class="m-0 mb-1 strong strikethrough">{{part.walkIn || 0 | currency: vm.currencyCode :'symbol':'1.2-2'}}</h3>
      </div>
    }
    @if (showPriceIq) {
      <div id="pricing_div_ZilliantYourPrice{{idSuffix}}" class="strong text-danger">{{ useCaps ? "YOUR PRICE" : "Your Price" }}</div>
    }
    <!-- Non-Zilliant -->
    @if (!showPriceIq) {
      <div id="pricing_div_NonZilliantPricing{{idSuffix}}" class="strong text-muted">{{ useCaps ? "CUSTOMER'S PRICE" : "Customer's Price" }}</div>
    }
    @if (part.isSpecialPricing) {
      <div id="pricing_div_IsSpecialPricing{{idSuffix}}" class="text-danger">Special Sale Price</div>
    }
    @if (part.adjustedPrice) {
      <h3 id="pricing_h3_IsSpecialSalePrice{{idSuffix}}" class="m-0 strong">
        <span id="pricing_span_price{{idSuffix}}" [ngClass]="{ 'text-danger': showPriceIq }">
        {{part.adjustedPrice || 0 | currency: vm.currencyCode :'symbol':'1.2-2'}}</span>
      </h3>
    }
    <!-- Price Verification -->
    <h3 class="m-0 strong align-items-center" style="font-size: 1.65rem">
      <span id="{{idPrefix}}pricing_span_verifiedPrice{{idSuffix}}" [ngClass]="{ 'text-danger': showPriceIq, 'strikethrough': part.adjustedPrice }">
        {{ (getVerifiedPrice(part, vm.selectVerifiedPriceEntities)) || 0 | currency: vm.currencyCode :'symbol':'1.2-2'}}
      </span>
      @if (priceAdjust$ | async) {
        <a id="pricing_a_PriceAdjust{{idSuffix}}" class="hyperlink text-danger"
          (click)="showPriceOverride()" href="javascript:void(0)">
          <i class="fas fa-tag fa-sm fa-rotate-90" aria-hidden="true"></i>
        </a>
      }
      @if (isPriceVerifiedByPart(part, vm.selectVerifiedPriceEntities)) {
        <span id="pricing_span_IsPriceVerified{{idSuffix}}" class="btn price-verify-icon" title="Price Verified">v</span>
      }
    </h3>
  </div>
  <!-- Coupons -->
  @if (partsData.sapCoupons?.length) {
    <coupons [part]="partsData" [idSuffix]="idSuffix" [currencyCode$]="currencyCode$"></coupons>
  }
  @if (loadingAnyProgramDiscounts$ | async) {
    <div>Looking for more discounts...</div>
  }
  <!-- Price Verification -->
  @if ((hasValidMscOrFleetCustomer$ | async) && displayType !== 'back-counter-tool') {
    <div id="pricing_div_isPayerCustomer{{idSuffix}}" class="gx-1">
      <a id="pricing_a_isPayerCustomer{{idSuffix}}" role="button" class="hyperlink" href="javascript:void(0)" (click)="showMscPriceVerifyPopup(part)">
        {{
        (isInternal$ | async)
        ? "Price Verification"
        : "Click here to see whether you qualify for a lower negotiated price!"
        }}
      </a>
      <sup class="fas fa-info-circle" aria-hidden="true"></sup>
    </div>
  }
  <!-- Core Price -->
  @if (part.corePrice > 0) {
    <div id="pricing_div_CorePrice{{idSuffix}}">
      <div class="strong text-muted">Core Price</div>
      <h3 class="m-0 strong">
        <span>{{part.corePrice || 0 | currency: vm.currencyCode :'symbol':'1.2-2'}}</span>
      </h3>
    </div>
  }
</ng-template>

<div *ngLet="{currencyCode: currencyCode$ | async,
  verifiedPrice: verifiedPrice$ | async,
  selectVerifiedPriceEntities: selectVerifiedPriceEntities$ | async
} as vm">
  <!-- Call for Pricing -->
  @if (!(isInternal$ | async)) {
    <div class="gy-3">
      @if (!part.isRushPart || (part.isRushPart && !part.isExtendedToBranch)) {
        <div>
          <div class="strong text-danger">Call for pricing</div>
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="pricingDisplayTemplate; context: { vm: vm }"></ng-container>
      }
    </div>
  }
  <!-- Create Part -->
  @if (isInternal$ | async) {
    <div class="gy-3">
      @if (!part.isRushPart || (part.isRushPart && !part.isExtendedToBranch)) {
        <div>
          @if (createPart$ | async) {
            <button type="button"
              class="btn btn-default yellow-btn d-flex align-items-center gx-1"
              (click)="createPart(part.rushPartNumber);" [disabled]="(cartIsLocked$ | async)">
              @if (!showCreatePartLoader) {
                <span>Create Part</span>
              }
              @if (showCreatePartLoader) {
                <span>Processing...</span>
                <span class="countLoader"></span>
              }
            </button>
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="pricingDisplayTemplate; context: { vm: vm }"></ng-container>
      }
    </div>
  }
  <!-- Pricing & Availability -->
</div>
